// Pure helper for the "new entry" form defaults (v2.6), extracted so the
// prefill rules are unit-testable without rendering the form (mirrors
// buildJiraOutputs).
//
// Returns the fields a *fresh* entry inherits from the day's existing entries,
// or null when there's nothing to inherit from. We carry the Activity forward
// — people usually log several sub-entries under the same activity, and the
// activity drives which fields (product/client/epic) show — but deliberately
// NOT the Product. A pre-selected product reads as "already valid" and used to
// slip unchanged into a follow-up entry that needed a different one (the
// reported hazard). Product is now always a deliberate pick.
export function entryFormPrefill(entries = []) {
  const sorted = [...entries]
    .filter((e) => e && !e.deleted)
    .sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
  if (!sorted[0]) return null;
  return { activityName: sorted[0].activityName };
}
